import { FC, useMemo } from "react"
import { useQueryClient } from "react-query"
import { Formik, Form, FormikValues } from "formik"
import * as Yup from 'yup'
import {
  FormikFileUpload,
  StatusErrorMessage,
  FormikNotesArea
} from "../../../../../components/widgets"

import { doFormSubmit, processNoteValues } from "../../../../../components/helpers"

import { cloneDeep, pickBy } from "lodash"
import { submitDLMPhase_3_1_1_1 } from "../../../../core/doclabel"
import { SubmitButtonRow } from "../../../../../components/layout"

const initPendingInspectionValues = {
  prototypeTestReport: 0,
  trainingRecord: 0,
  methodOfStatement: 0,
  productConstructionDrawing: 0,
  sitePlanDrawing: 0,
  siteChecklist: 0,
  setscoROI: 0,
  prototypeTestReportAttachmentName: '',
  trainingRecordAttachmentName: '',
  methodOfStatementAttachmentName: '',
  productConstructionDrawingAttachmentName: '',
  sitePlanDrawingAttachmentName: '',
  siteChecklistAttachmentName: '',
  setscoROIAttachmentName: '',
  note: '',
  noteAttachments: [],
}

const schema = Yup.object({
  prototypeTestReport: Yup.number().integer(),
  trainingRecord: Yup.number().integer(),
  methodOfStatement: Yup.number().integer(),
  productConstructionDrawing: Yup.number().integer(),
  sitePlanDrawing: Yup.number().integer(),
  siteChecklist: Yup.number().integer(),
  setscoROI: Yup.number().integer(),
  prototypeTestReportAttachmentName: Yup.string().trim(),
  trainingRecordAttachmentName: Yup.string().trim(),
  methodOfStatementAttachmentName: Yup.string().trim(),
  productConstructionDrawingAttachmentName: Yup.string().trim(),
  sitePlanDrawingAttachmentName: Yup.string().trim(),
  siteChecklistAttachmentName: Yup.string().trim(),
  setscoROIAttachmentName: Yup.string().trim(),
  note: Yup.string().trim().label('Note'),
  noteAttachments: Yup.array(),
})

const DOC_FIELDS = [
  'prototypeTestReport',
  'trainingRecord',
  'methodOfStatement',
  'productConstructionDrawing',
  'sitePlanDrawing',
  'siteChecklist',
  'setscoROI'
];

type Props = {
  id: number
  appID: number
  projectName: string
  projectLocation: string
  doClose: Function
}

const PendingInspectionForm: FC<Props> = ({id, appID, projectName, projectLocation, doClose}) => {
  const queryClient = useQueryClient()


  const initValues = useMemo(() => {
    return cloneDeep(initPendingInspectionValues);
  }, []);


  const doSubmit = async (values: any, actions: FormikValues) => {

    const { setStatus, setSubmitting } = actions;

    const payload = { siteApplicationid: id };
    processNoteValues(values, payload);
    
    const _model = pickBy(values, (value, key) => (value && (DOC_FIELDS.indexOf(key) > -1)));

    if (_model) {
      Object.assign(payload, { 
        dlmWebPhase0SitesModel: {
          id,
          ..._model,
        }
      });
    };

    await doFormSubmit(submitDLMPhase_3_1_1_1, payload, setStatus, setSubmitting, () => {
      queryClient.invalidateQueries(['DLMAPPLICATION-LOAD', { dlmappid: appID } ]);
      doClose();
    });
  }

  return(
  <Formik
    initialValues={initValues}
    validationSchema={schema}
    enableReinitialize={true}
    onSubmit={doSubmit}
  >
  {({status}) => (
  <Form id='kt_doclabel_pending_inspection_form' className='form' noValidate>
    <div
      className='d-flex flex-column px-2'
    >
    <h3>{`Arrange Labelling : ${projectName} (${projectLocation})`}</h3>
    <div className='separator border-gray-200 mb-2'></div>
      <div className="row mt-4">
        <div className="col-12 fw-bold fs-6 mb-1">Supporting Documents :</div>
      </div>
      <div className="row mb-4">
        <FormikFileUpload size="12 col-md-6" label="Prototype Test Report" name='prototypeTestReport' acceptFiles="ApplicantFileFormats" />
        <FormikFileUpload size="12 col-md-6" label="Training Record" name='trainingRecord' acceptFiles="ApplicantFileFormats" />
        <FormikFileUpload size="12 col-md-6" label="Method of Statment" name='methodOfStatement' acceptFiles="ApplicantFileFormats" />
        <FormikFileUpload size="12 col-md-6" label="Product Construction DWG" name='productConstructionDrawing' acceptFiles="ApplicantFileFormats" />
        <FormikFileUpload size="12 col-md-6" label="Site Plan/Site DWG" name='sitePlanDrawing' acceptFiles="ApplicantFileFormats" />
        <FormikFileUpload size="12 col-md-6" label="Site Checklist" name='siteChecklist' acceptFiles="ApplicantFileFormats" />
        <FormikFileUpload size="12 col-md-6" label="Setsco ROI" name='setscoROI' acceptFiles="ApplicantFileFormats"  />
      </div>

      <FormikNotesArea />

      <StatusErrorMessage status={status} />      
      <SubmitButtonRow doClose={doClose} cancelText="Discard" submitText="Submit" />      
    </div>
  </Form>
  )}
  </Formik>
  )
}

export { PendingInspectionForm }